module.exports = __webpack_public_path__ + "static/media/telemedicine.ae55af37.svg";